import { LOCAL_STORAGE_KEYS } from '@/consts/local-storage-keys';
import type { LoginData } from '@/types/auth';
import { z } from 'zod';

const UserInfoSchema = z.object({
  userId: z.number(),
  userName: z.string(),
  email: z.string(),
  isStaff: z.boolean(),
  isSystemAdmin: z.boolean().optional(),
});

function createAuthStorage(tokenKey: string, userInfoKey: string) {
  return {
    setToken(token: string): void {
      localStorage.setItem(tokenKey, token);
    },

    getToken(): string | null {
      return localStorage.getItem(tokenKey);
    },

    removeToken(): void {
      localStorage.removeItem(tokenKey);
    },

    isAuthenticated(): boolean {
      return !!this.getToken();
    },

    setUserInfo(userInfo: Omit<LoginData, 'token'>): void {
      localStorage.setItem(userInfoKey, JSON.stringify(userInfo));
    },

    getUserInfo(): Omit<LoginData, 'token'> | null {
      const userInfoString = localStorage.getItem(userInfoKey);
      if (!userInfoString) return null;

      try {
        const parsed: unknown = JSON.parse(userInfoString);
        const validated = UserInfoSchema.parse(parsed);
        return validated;
      } catch {
        this.clearAll();
        return null;
      }
    },

    removeUserInfo(): void {
      localStorage.removeItem(userInfoKey);
    },

    clearAll(): void {
      this.removeToken();
      this.removeUserInfo();
    },
  };
}

/** 런치패드 위저드 전용 인증 스토리지 — MPMS 관리자 tokenStorage와 분리된 키를 사용한다. */
export const launchpadAuthStorage = createAuthStorage(
  LOCAL_STORAGE_KEYS.LAUNCHPAD_AUTH_TOKEN,
  LOCAL_STORAGE_KEYS.LAUNCHPAD_USER_INFO,
);
